import {
  Component,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DxTreeListComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { FusionAuthService } from '../../../../../shared/services/fusion-auth';
import { ScreenService, UrlProviderService } from '../../../../../shared/services/general';
import { OrdersService } from '../../../../shared/services/orders.service';
import { ResultBase } from '../../models/results';

@Component({
  selector: 'app-clinical-results',
  templateUrl: './clinical-results.component.html',
  styleUrls: ['./clinical-results.component.scss'],
})
export class ClinicalResultsComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('tree', { static: true }) private tree?: DxTreeListComponent;
  @Input() public orderId: number = -1;
  public isLoading = false;
  public dataSource: ResultBase[] = [];
  public expandedKeys: any[] = [];
  public isPhoneOrTablet: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private ordersService: OrdersService,
    private urlProvider: UrlProviderService,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private fusionAuthService: FusionAuthService,
    private screen: ScreenService,
  ) {
  }

  public ngOnInit() {
    this.isLoading = true;
    this.ordersService.getOrderClinicalResults(this.orderId)
      .pipe(take(1))
      .subscribe(results => {
        this.dataSource = results;
        this.expandedKeys = results.map(r => r.key);
      });

    this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    });
  }

  public ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    if (changes.orderId.currentValue) {
      this.isLoading = true;
      this.ordersService.getOrderClinicalResults(changes.orderId.currentValue)
        .pipe(take(1))
        .subscribe(results => {
          this.dataSource = results;
          this.expandedKeys = results.map(r => r.key);
        });
    }
  }

  public calculateNameFilter(value: any, selectedFilterOperations: any, target: any) {
    const column = this as any;
    if (target === 'filterRow') {
      return [['name', 'contains', value.toUpperCase()]];
    }
    return column.defaultCalculateFilterExpression.apply(this, arguments);
  }

  public conditionalRendering(e: any) {
    if (e.rowType === 'data' && e.data.isAbnormal === true && e.data.result !== 'PENDING') {
      this.renderer.addClass(e.cellElement, 'ocl-red-text');
      if (e.column.caption === 'Flag') {
        this.renderer.setStyle(e.cellElement, 'font-weight', '500');
      }
    }
  }

  public onContentReady(e: any) {
    /*if (this.isPhoneOrTablet) {
      const itemsWithChildren = e.element.querySelectorAll('tr[aria-expanded]') as HTMLCollection[];
      itemsWithChildren.forEach(x => {
        const columnAdaptive = (x as any).lastChild;
        if (columnAdaptive.firstChild) {
          columnAdaptive.firstChild.hidden = true;
        }
      });
    }*/
    e.component.updateDimensions();
  }

  public transformYourHtml(htmlTextWithStyle: any) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
